export const whyChooseCards = [
    {
        id: 1,
        title: 'Индивидуальный\n' +
            'подход',
        text: "– подбираем\n" +
            "удобный\n" +
            "график занятий",
    },
    {
        id: 2,
        title: 'Современные методики –',
        text: "интерактивные классы и онлайн-обучение",
    },
    {
        id: 3,
        title: 'Качественная подготовка – 98%',
        text: "наших учеников сдают экзамены в ГИБДД с первого раза",
    },
    {
        id: 4,
        title: 'Доступные цены',
        text: "– различные пакеты обучения и рассрочка платежа",
    },
]